import React from 'react';
import { PoweroffOutlined } from '@ant-design/icons';
//import { Dropdown, Menu, Space } from 'antd';
import { connect } from 'react-redux';
import { Router, Route, NavLink } from 'react-router-dom';
import HomePage from '../components/pages/home';
import SignIn from '../components/pages/login';
import RegisterHappyCall from '../components/pages/happyCall';
import RegisterAddress from '../components/pages/registerAddress';
import RegisterCode from '../components/pages/registerCode';
import registerService from '../components/pages/registerService';
import { HomeOutlined } from '@ant-design/icons';
import { history } from '../helper/history';
import { Layout, Dropdown, Menu } from 'antd';
import happyCallProductList from '../components/pages/happyCallProductList';
import technicianInfo from '../components/pages/technicianInfo';
import logo from './logo.png'
import StoreFactor from '../components/pages/StoreFactor';
import registerServiceQrCode from '../components/pages/registerServiceQrCode';
import registerServicePublic from '../components/pages/registerServicePublic';
import registerCounsel from '../components/pages/registerCounsel';
class App extends React.Component {
    constructor(props) {
        super(props);
        history.listen((location, action) => {
        });
        console.log(this.getCookie('au'), 'cookies');
        if (this.getCookie('au') === undefined)
            localStorage.clear();

    }
    getCookie(cookieName) {
        let cookie = {};
        document.cookie.split(';').forEach(function (el) {
            let [key, value] = el.split('=');
            cookie[key.trim()] = value;
        })
        return cookie[cookieName];
    }
    menu() {
        return (<Menu>
            <Menu.Item key="0" >
                <a href='/' onClick={(e) => { localStorage.clear(); }}><PoweroffOutlined /> <b>خروج</b></a>
            </Menu.Item>
        </Menu>
        )
    }
    render() {
        const isLogined = this.props.logined
        const { Header, Footer, Content } = Layout;

        return (
            <Layout>
                <Header style={{textAlign:'center'}}>
                    <Router history={history}>
                        <p className='iran'></p>
                        {
                            (this.props.logined) ? <Dropdown overlay={this.menu} trigger={['click']} className='iran'>
                                <a onClick={(e) => e.preventDefault()}>
                                    کاربر جاری:{this.props.currentMobile}
                                </a>
                            </Dropdown> : ''
                        }
                        <NavLink activeClassName="active" danger to="/">
                            {/* <HomeOutlined color='red' /> */}
                            <img src={logo} alt={"logo"} className="logo" />
                        </NavLink>


                    </Router>

                </Header>
                <Content><Router history={history}>
                    <div>
                        {/* {this.props.userInfo.firstName}
                        {this.props.logined + ' ' + this.props.currentMobile} */}
                        <Route exact path="/" component={HomePage} />
                        <Route exact path="/login" component={SignIn} />
                        <Route exact path="/registerCode" component={RegisterCode} />
                        <Route exact path="/registerService" component={(isLogined) ? registerService : SignIn} />
                        <Route exact path="/registerAddress" component={(isLogined) ? RegisterAddress : SignIn} />
                        <Route path="/regRequest" component={HomePage} />
                        <Route path="/registerHappyCall" component={RegisterHappyCall} />
                        <Route path="/HappyCallProductList" component={happyCallProductList} />
                        <Route path="/StoreFactor" component={StoreFactor} />
                        <Route path="/technicianInfo" component={technicianInfo} />
                        <Route path="/registerServiceQrCode/:id" component={registerServiceQrCode} />
                        <Route path="/registerServicePublic" component={registerServicePublic} />
                        <Route path="/registerCounsel" component={registerCounsel} />

                    </div>
                </Router></Content>
                <Footer><span className='version'>version 2.00</span></Footer>
            </Layout>

        );
    }
}
const mapStateToProps = state => ({
    logined: state.user.isAuthenticate,
    currentMobile: state.user.currentMobile,
    userInfo: state.user.userInfo
});
const connectedApp = connect(mapStateToProps, null)(App);
export { connectedApp as App };